import React from 'react';

const MarkeDashboard = () => (
  <div>MarkeDashboardt</div>
  );

export default MarkeDashboard;
